import { api } from './client';
import type { WorkPackage, WorkPackageDetail, WpStatus, Subtask, Resolution } from '../types/dev';

export interface ListWpsParams {
  is_idea?: '0' | '1';
  status?: WpStatus;
  title?: string;
}

export const listWps = (params?: ListWpsParams): Promise<WorkPackage[]> =>
  api.get<WorkPackage[]>('/dev/wps', { params }).then((r) => r.data);

export const getWp = (wpNumber: string): Promise<WorkPackageDetail> =>
  api.get<WorkPackageDetail>(`/dev/wps/${wpNumber}`).then((r) => r.data);

export const uploadWp = (form: FormData): Promise<{ wp: WorkPackage; resolution: Resolution }> =>
  api.post<{ wp: WorkPackage; resolution: Resolution }>('/dev/wps', form).then((r) => r.data);

export const setWpStatus = (id: number, status: WpStatus): Promise<void> =>
  api.patch(`/dev/wps/${id}/status`, { status }).then(() => undefined);

export const setWpIdea = (id: number, isIdea: boolean): Promise<void> =>
  api.patch(`/dev/wps/${id}/idea`, { is_idea: isIdea }).then(() => undefined);

export const setSubtasks = (id: number, subtasks: Subtask[]): Promise<void> =>
  api.patch(`/dev/wps/${id}/subtasks`, { subtasks }).then(() => undefined);

export const reportBug = (id: number, note?: string): Promise<{ bug_count: number }> =>
  api.post<{ bug_count: number }>(`/dev/wps/${id}/bug`, { note }).then((r) => r.data);

export const deleteWp = (id: number): Promise<void> =>
  api.delete(`/dev/wps/${id}`).then(() => undefined);

export const downloadBlob = (id: number): Promise<Blob> =>
  api.get(`/dev/wps/${id}/blob`, { responseType: 'blob' }).then((r) => r.data as Blob);

export const fetchNextWpId = (): Promise<{ next_id: number; next_wp: string }> =>
  api.get<{ next_id: number; next_wp: string }>('/dev/wps/nextId').then((r) => r.data);

export const createIdea = (title: string, description?: string): Promise<WorkPackage> =>
  api.post<WorkPackage>('/dev/wps/idea', { title, description }).then((r) => r.data);
